<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col class="mb-1">
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMRelationList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <EXCMRelationForm
                    v-if="item"
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations"
                    :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMRelationForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMRelationForm,
    Loader
  },

  data () {
    return {
      item: {},
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmrelation/update/isLoading',
      error: 'excmrelation/update/error',
      deleteError: 'excmrelation/del/error',
      deleteLoading: 'excmrelation/del/isLoading',
      created: 'excmrelation/create/created',
      deleted: 'excmrelation/del/deleted',
      retrieved: 'excmrelation/update/retrieved',
      updated: 'excmrelation/update/updated',
      violations: 'excmrelation/update/violations'
    }),
    mobileView () {
      return this.$store.state.mobileView
    }
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMRelationList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmrelation/create/reset',
      deleteItem: 'excmrelation/del/del',
      delReset: 'excmrelation/del/reset',
      retrieve: 'excmrelation/update/retrieve',
      updateReset: 'excmrelation/update/reset',
      update: 'excmrelation/update/update',
      updateRetrieved: 'excmrelation/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmrelation ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
